/**
 * Arquivo responsável por centralizar em forma de constantes
 * as unidades de medidas usadas no sistema.
 */

export const CELSIUS               = "C";
export const MILI_AMP              = "mA";
export const KILOMETER             = "Km";
export const VOLT                  = "V";
export const DECIBEL               = "dB";
export const DECIBEL_MILIWAT       = "dBm";
export const DECIBEL_BY_KILOMETER  = `${DECIBEL}/${KILOMETER}`;
